import { render, staticRenderFns } from "./McaPetternRecog.vue?vue&type=template&id=6fe42b38&scoped=true"
import script from "./McaPetternRecog.vue?vue&type=script&lang=ts"
export * from "./McaPetternRecog.vue?vue&type=script&lang=ts"
import style0 from "./McaPetternRecog.vue?vue&type=style&index=0&id=6fe42b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe42b38",
  null
  
)

export default component.exports